"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find");
var _courseItemCommon = _interopRequireDefault(require("@/components/courseItemCommon.vue"));
var _index = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    courseItemCommon: _courseItemCommon.default
  },
  data: function data() {
    return {
      actNum: 0,
      navList: [{
        name: "专业资源"
      }, {
        name: "公共资源"
      }],
      sportsList: [],
      antiEpidemicList: [],
      footballList: [],
      exerciseList: [],
      collegeSportsList: [],
      supplementaryList: [],
      commonList: [],
      page: {
        pageNumber: 1,
        pageSize: 20
      },
      total: 0,
      totalNumber: 0,
      loading: false
    };
  },
  methods: {
    tabChange: function tabChange(index) {
      this.actNum = index;
      if (index == 0) {
        this.page.pageNumber = 1;
        this.page.pageSize = 20;
        this.getCourseList();
      } else if (index == 1) {
        this.page.pageNumber = 1;
        this.page.pageSize = 20;
        this.getCourseList1();
      }
    },
    handleSizeChange: function handleSizeChange(e) {
      if (this.actNum == 0) {
        this.page.pageSize = e;
        this.page.pageNumber = 1;
        this.getCourseList();
      } else {
        this.page.pageSize = e;
        this.page.pageNumber = 1;
        this.getCourseList1();
      }
    },
    handleCurrentChange: function handleCurrentChange(e) {
      if (this.actNum == 0) {
        this.page.pageNumber = e;
        this.getCourseList();
      } else {
        this.page.pageNumber = e;
        this.getCourseList1();
      }
    },
    goTO: function goTO(Url) {
      if (!Url) return;
      window.open(Url);
    },
    getCourseInfo: function getCourseInfo(item) {
      if (!item || !item.courseInfo) return [];
      if (Array.isArray(item.courseInfo)) return item.courseInfo;
      try {
        var courseInfo = JSON.parse(item.courseInfo);
        return Array.isArray(courseInfo) ? courseInfo : [];
      } catch (e) {
        return [];
      }
    },
    getCourseUrl: function getCourseUrl(item) {
      if (!item) return '';
      var firstCourse = this.getCourseInfo(item).find(function (i) {
        return i && i.url;
      });
      return firstCourse && firstCourse.url || item.courseLink || item.courseUrl || item.linkUrl || item.url || '';
    },
    getCourseList: function getCourseList() {
      var _this = this;
      (0, _index.getReceptionList)({
        courseName: "",
        courseSource: "",
        courseType: "13",
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        projectLevel: "",
        provinceId: this.$store.getters.provinceId,
        schoolId: "",
        majorName: "",
        courseConType: "体育",
        isSpecial: true,
        showStatus: 1
      }).then(function (res) {
        var rows = res.rows || [];
        _this.sportsList = [];
        _this.antiEpidemicList = [];
        _this.footballList = [];
        _this.exerciseList = [];
        _this.collegeSportsList = [];
        _this.supplementaryList = [];
        rows.filter(function (item) {
          return item.courseConType === "体育" || (item.courseName || "").includes("体育");
        }).forEach(function (item) {
          if (item.detailType == "体育竞赛") {
            _this.sportsList.push(item);
          } else if (item.detailType == "抗疫微视频") {
            _this.antiEpidemicList.push(item);
          } else if (item.detailType == "校园足球") {
            _this.footballList.push(item);
          } else if (item.detailType == "运动") {
            _this.exerciseList.push(item);
          } else if (item.detailType == "大学体育") {
            _this.collegeSportsList.push(item);
          } else if (item.detailType == "运动辅助") {
            _this.supplementaryList.push(item);
          } else {
            _this.supplementaryList.push(item);
          }
        });
        _this.total = res.total;
      });
    },
    getCourseList1: function getCourseList1() {
      var _this2 = this;
      this.loading = true;
      this.commonList = [];
      this.totalNumber = 0;
      (0, _index.getReceptionList)({
        courseName: "",
        courseSource: "",
        courseType: "11",
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        projectLevel: "",
        provinceId: this.$store.getters.provinceId,
        schoolId: "",
        majorName: "",
        isSpecial: true,
        showStatus: 1
      }).then(function (res) {
        _this2.commonList = res.rows || [];
        _this2.totalNumber = res.total;
        _this2.loading = false;
      });
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getCourseList();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};